import { createReducer } from 'utils/ReduxUtils';

import * as actionTypes from '../../../actionTypes';

const initialState = false;

const isLoading = () => true;
const isEnding = () => false;

export default createReducer(initialState, {
  [actionTypes.PATCH_STATUS_REQUEST]: isLoading,
  [actionTypes.PATCH_STATUS_SUCCESS]: isEnding,
  [actionTypes.PATCH_STATUS_FAILURE]: isEnding,
});
